<template>
  <AeModal v-model="isOpen" :title="title" size="large" flex-body>
    <FarmCenterForm
      ref="formRef"
      :farm-center-id="farmCenterId"
      :mode="mode"
      @submit="onSubmit"
      @cancel="isOpen = false"
    />
    <template #footer>
      <div class="modal-actions">
        <AeButton variant="secondary" @click="formRef?.handleCancel()">
          {{ t('farmCenterFormModal.cancel') }}
        </AeButton>
        <AeButton variant="primary" data-testid="btn-submit-farm-center" :loading="formRef?.saving" @click="formRef?.handleSubmit()">
          {{ farmCenterId ? t('farmCenterFormModal.saveChanges') : t('farmCenterFormModal.createFarm') }}
        </AeButton>
      </div>
    </template>
  </AeModal>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { AeButton, AeModal } from '@aevue/components'
import FarmCenterForm from './FarmCenterForm.vue'

const { t } = useI18n()

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  farmCenterId: { type: [String, Number], default: null },
  mode: { type: String, default: 'local' }
})

const emit = defineEmits(['update:modelValue', 'submit'])

const router = useRouter()
const formRef = ref(null)

const isOpen = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v)
})

const title = computed(() => props.farmCenterId ? t('farmCenterFormModal.editFarmTitle') : t('farmCenterFormModal.newFarmTitle'))

function onSubmit(data) {
  const isNew = !props.farmCenterId
  emit('submit', data)
  isOpen.value = false
  // mode 'online' (org-admin): si resta nella pagina, l'azienda è creata server-side
  if (isNew && data && props.mode !== 'online') {
    router.push(`/poderi/${data}`)
  }
}
</script>

<style scoped>
.modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}
</style>
